module.exports = __webpack_public_path__ + "ec5bd6c5848511f4adaf86a64af28e2c.fbx";